module.exports = __webpack_public_path__ + "static/media/cerveny-semafor-readonly.fd61a514.svg";